import { render, staticRenderFns } from "./ThirdPartyList.vue?vue&type=template&id=5886fb2c&"
import script from "./ThirdPartyList.vue?vue&type=script&lang=ts&"
export * from "./ThirdPartyList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5886fb2c')) {
      api.createRecord('5886fb2c', component.options)
    } else {
      api.reload('5886fb2c', component.options)
    }
    module.hot.accept("./ThirdPartyList.vue?vue&type=template&id=5886fb2c&", function () {
      api.rerender('5886fb2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/thirdParty/ThirdPartyList.vue"
export default component.exports